import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { formatDateTime } from 'services/utils';
import './ConveraStatementsTableRowContent.scss';

const ConveraStatementsTableRowContent = ({ isLoading, fileData, handleDownloadFileById }) => {
  const getInfoBlock = (blockInfo, callBack) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'convera-statements-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (callBack) {
      return (
        // eslint-disable-next-line
        <p className={'convera-statements-table-cell-info-link'} onClick={callBack}>
          {blockInfo}
        </p>
      );
    } else {
      return <p>{blockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'convera-statements-table-cell'}>
        {getInfoBlock(fileData.filename, () => handleDownloadFileById(fileData.id))}
      </td>
      <td className={'convera-statements-table-cell'}>{getInfoBlock(fileData.type)}</td>
      <td className={'convera-statements-table-cell'}>{getInfoBlock(formatDateTime(fileData.created_at))}</td>
    </tr>
  );
};

ConveraStatementsTableRowContent.propTypes = {
  isLoading: PropTypes.bool,
  fileData: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      type: PropTypes.string,
      created_at: PropTypes.string
    }),
    PropTypes.oneOf([null])
  ]),
  handleDownloadFileById: PropTypes.func
};

export default ConveraStatementsTableRowContent;
